import { clientEnv } from "@/env/client";
import { isBrowser } from "@/env/config";
import { datadogLogs } from "@datadog/browser-logs";
import type { Level, LogEvent } from "pino";

let initialized = false;
const initDatadogLogs = () => {
  if (initialized) return;
  if (
    clientEnv.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN &&
    clientEnv.NEXT_PUBLIC_DATADOG_APPLICATION_ID &&
    isBrowser() &&
    !initialized
  ) {
    datadogLogs.init({
      clientToken: clientEnv.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: "ap1.datadoghq.com",
      service: "mykenpo",
      env: clientEnv.NEXT_PUBLIC_VERCEL_ENV,
      version: clientEnv.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || "unknown",
      sessionSampleRate: 100,
      silentMultipleInit: true,
    });
    initialized = true;
  }
};
/**
 * ブラウザログをDatadogに送信する
 */
export const sendLogToDatadog = async (level: Level, logEvent: LogEvent) => {
  initDatadogLogs();
  if (!initialized) return;

  let logCtx = logEvent.messages[0];
  const error =
    typeof logCtx !== "string" ? (logCtx?.error ?? logCtx.err) : undefined;
  const message = typeof logCtx !== "string" ? logEvent.messages[1] : logCtx;

  logCtx = { context: logCtx };

  switch (level) {
    case "fatal":
      return datadogLogs.logger.critical(message, logCtx, error);
    case "error":
      return datadogLogs.logger.error(message, logCtx, error);
    case "warn":
      return datadogLogs.logger.warn(message, logCtx, error);
    case "info":
      return datadogLogs.logger.info(message, logCtx, error);
    case "debug":
    case "trace":
      return datadogLogs.logger.debug(message, logCtx, error);
  }
};
